"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewEnergyMasterTest extends new_item_1.default {
    constructor(newEnergyMasterTest) {
        super();
        this.recipients = newEnergyMasterTest.recipients;
        this.site = newEnergyMasterTest.site;
        this.siteId = newEnergyMasterTest.siteId;
        this.forecastedStart = newEnergyMasterTest.forecastedStart;
        this.solarProduction = newEnergyMasterTest.solarProduction;
        this.consumption = newEnergyMasterTest.consumption;
        this.dataJson = newEnergyMasterTest.dataJson;
        this.flexibleConsumption = newEnergyMasterTest.flexibleConsumption;
    }
}
exports.default = NewEnergyMasterTest;
//# sourceMappingURL=new-energyMasterTest.js.map